import React,{ PureComponent } from 'react'
import { Input,Spin } from 'antd';
import PropTypes from 'prop-types';
import Lang from "@components/Lang/Lang";
// import LocalHistoryStore from "./localHistoryStore";
import LocalHistoryStore from "../../store/localHistoryStore";
import SearchHistoryPanel from "./SearchHistoryPanel";
import { Button, Popover } from 'antd';
// import { isEmpty, isEmptyObject } from "../../utils/utils";
import SearchApiService from "./SearchSelector.action";

// const { Search } = Input;
// const { Option } = Select;

/**
 * 头部 搜索
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 * 扩展：
 **/
class HeaderSearch extends PureComponent{
    static propTypes = {
        title: PropTypes.string.isRequired,
        initValue: PropTypes.string,
    }
    static defaultProps = {
        title:'',
        initValue:'',
    };
    constructor(props){
        super(props)
        this.state = {
            loading:false,
            isShowHistoryPanel: false,
            searchText: '',
            showSearchResult:false,//展示搜索结果
        }
        this.localStore = new LocalHistoryStore();
    }
    setSearchKey(searchText=""){
        this.setState({
            searchText:searchText
        })
    }
    // 加载中
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    search (words){
        console.log("search str", words)
        if (words) {
            this.localStore.set(words);
            this.loading(true);
            SearchApiService.fetch({keyword:words}).then(res=>{
                this.loading(false);
                const dat = res.data||{};
                const {success,valid, model } = dat;
                if (success &&valid) {
                    const data = model || {}
                    const {buyerList,containerList,poList } = data;
                    this.setState({
                        showSearchResult:true,
                        isShowHistoryPanel:true,
                        buyerList: buyerList || [],
                        containerList: containerList || [],
                        poList: poList || [],
                    })
                }
            }).catch(err=>{
                this.loading(false);
                // this.setState({
                //     showSearchResult:true,
                //     isShowHistoryPanel:true,
                //     buyerList:  [{
                //         buyerCode: "RUS10120",
                //         buyerId: 9638, // /customer/detail?id=
                //         buyerName: "ИП Поликанин",
                //     },{
                //         buyerCode: "RU13568",
                //         buyerId: 16694,
                //         buyerName: "Земцова Татьяна Владимировна",
                //     }],
                //     containerList: [{
                //         containerCode: "RU20230023",
                //         containerId: 137, ///shipperManagement/shippingOrder/detail?137
                //         type:2
                //
                //     },{
                //         containerCode: "RU20220019",
                //         containerId: 110,// /shipperManagement/estimatedShippingOrder/detail?110
                //         type:1,
                //     }],
                //     poList: [{
                //         poCode: "RU06075T23062601-6",
                //         poId: 17492, // /order/sale/detail?id=
                //     },{
                //         poCode: "RU06075T23062601-7",
                //         poId: 17493,
                //     }],
                // })
            })
        }
    }
    // 清除本地搜索记录
    toClearHistory() {
        this.localStore.removeAll()
        this.setState({
            localList: []
        })
    }
    //本地历史搜索记录
    renderLocalHistoryPanel(callback) {
        const list = this.getLocalHistoryByKeyword(this.state.searchText);
        this.setState({
            localList: list||[]
        },callback(list))
    }
    /**
     * 获取本地关键字
     * @param keyword
     * @return {[]|*[]}
     */
    getLocalHistoryByKeyword(keyword) {
        return this.localStore.get(keyword, 10) || []
    }
    /**
     * 打开 隐藏面板
     **/
    handleOpenChange=(flag=false)=>{
        if(flag){
            this.renderLocalHistoryPanel((list=[])=>{
                if(list.length>0){
                    this.setState({
                        isShowHistoryPanel: true
                    });
                }
            })
        }else this.setState({
            isShowHistoryPanel: flag,
            showSearchResult:false
        });

    }
    componentDidMount(){
        if(this.props.onRef)  this.props.onRef(this);
    }
    render() {
        const { searchText,isShowHistoryPanel,loading,localList,showSearchResult,buyerList,containerList,poList } = this.state;
        return (<div className={"search"}>
            <Popover content={<Spin spinning={loading}>
                        <SearchHistoryPanel localList={localList}
                                            //history={this.props.history}
                                            wrapperCls={'s-item-local'}
                                            toClearHistory={() => {
                                                this.toClearHistory()
                                            }}
                                            onClickFun={(keywords) => {
                                                this.search(keywords);
                                            }}
                                            showSearchResult={showSearchResult}
                                            buyerList={buyerList}
                                            containerList={containerList}
                                            poList={poList} />
                    </Spin>}
                     overlayClassName={"headerSearchPopover"}
                     trigger="click"
                     placement="bottom"
                     arrow={false}
                     open={isShowHistoryPanel}
                     onOpenChange={this.handleOpenChange.bind(this)}>
                    <Input placeholder={Lang({id: 'SouSuoKeHuDingDanJiGui', default: '搜索客户/订单/集柜'})}
                           allowClear
                           onChange={(e)=>this.setSearchKey(e.target.value)}
                           // onClick={(e)=>this.onInputFocus(isShowHistoryPanel)}
                           onPressEnter={()=>this.search(searchText)}
                           suffix={<i className="ri-search-line cursor-p" onClick={()=>this.search(searchText)} />}
                    />
            </Popover>

        </div>)
    }
}
export default HeaderSearch;
